import { IPagination } from 'app/types/common';

export interface IUsersState {
  readonly usersById?: any;
  readonly userIds?: string[];
  readonly saved?: boolean;
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddUser?: boolean;
  readonly backendErrors?: any;
  readonly currentUserId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly requestedData?: any;
  readonly pagination?: IPagination;
}

export interface IUsersSelector extends IUsersState {
  readonly currentUser?: any;
  readonly getUsersFilteredByTagInSelectFormat?: any;
  readonly usersByIdInSelectFormat?: any;
}

export enum UsersActionTypes {
  GET_ALL_USERS_REQUESTED = 'redux-app/users/GET_ALL_USERS_REQUESTED',
  GET_ALL_USERS_PENDING = 'redux-app/users/GET_ALL_USERS_PENDING',
  GET_ALL_USERS_SUCCESS = 'redux-app/users/GET_ALL_USERS_SUCCESS',
  GET_ALL_USERS_FAIL = 'redux-app/users/GET_ALL_USERS_FAIL',
  GET_USER_REQUESTED = 'redux-app/users/GET_USER_REQUESTED',
  GET_USER_PENDING = 'redux-app/users/GET_USER_PENDING',
  GET_USER_SUCCESS = 'redux-app/users/GET_USER_SUCCESS',
  GET_USER_FAIL = 'redux-app/users/GET_USER_FAIL',
  UPDATE_USER_REQUESTED = 'redux-app/users/UPDATE_USER_REQUESTED',
  UPDATE_USER_PENDING = 'redux-app/users/UPDATE_USER_PENDING',
  UPDATE_USER_SUCCESS = 'redux-app/users/UPDATE_USER_SUCCESS',
  UPDATE_USER_FAIL = 'redux-app/users/UPDATE_USER_FAIL',
  CREATE_USER_REQUESTED = 'redux-app/users/CREATE_USER_REQUESTED',
  CREATE_USER_PENDING = 'redux-app/users/CREATE_USER_PENDING',
  CREATE_USER_SUCCESS = 'redux-app/users/CREATE_USER_SUCCESS',
  CREATE_USER_FAIL = 'redux-app/users/CREATE_USER_FAIL',
  DELETE_USER_REQUESTED = 'redux-app/users/DELETE_USER_REQUESTED',
  DELETE_USER_PENDING = 'redux-app/users/DELETE_USER_PENDING',
  DELETE_USER_SUCCESS = 'redux-app/users/DELETE_USER_SUCCESS',
  DELETE_USER_FAIL = 'redux-app/users/DELETE_USER_FAIL',
  SELECT_USER_REQUESTED = 'redux-app/users/SELECT_USER_REQUESTED',
}

export default null;
